import { EMPTY_OBJECT } from '../../../constants/common'
import Button from '../../Button'
import { IconChevron } from '../../Icon'

import {
  NAV_ARROW_BUTTON_DIRECTION,
  NAV_ARROW_BUTTON_SIZE,
} from './NavArrowButton.constants'

import * as styles from './NavArrowButton.module.css'

function NavArrowButton({
  Component = Button.Flat,
  Icon = IconChevron,
  className = styles.NavArrowButton,
  direction = NAV_ARROW_BUTTON_DIRECTION,
  disabled,
  iconProps: {
    className: iconClassName = styles.icon,
    ...iconProps
  } = EMPTY_OBJECT,
  size = NAV_ARROW_BUTTON_SIZE,
  ...componentProps
}) {
  return (
    <Component
      {...componentProps}
      beforeIconProps={{
        ...iconProps,
        Icon,
        className: iconClassName,
        iconProps: {
          direction,
        },
      }}
      className={className}
      disabled={disabled}
      height={size}
    />
  )
}

export default NavArrowButton
